/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { LayoutConfirmModalComponent } from '@layout/confirm-modal/confirm-modal.component';
import {
    DatalistAnagrafica,
    Opera,
    Paginator,
    Rilievo,
    Sorting,
    SortingDirectionEnum
} from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { RilievoService } from '@shared/services/rilievo.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-modifica-rilievo',
    templateUrl: './modifica-rilievo.component.html'
})
export class PagesGestioneRilievoModificaRilievoComponent implements OnInit {

    public criteriaForm: FormGroup;
    public datalist: DatalistAnagrafica;
    public rilievo: Rilievo;
    public opereAssociateList: Opera[] | any = [];
    public paginator: Paginator = new Paginator();
    public tableSort: Sorting[] = [
        { field: 'idOpera', direction: SortingDirectionEnum.EMPTY },
        { field: 'denProv', direction: SortingDirectionEnum.EMPTY },
        { field: 'denComune', direction: SortingDirectionEnum.EMPTY },
    ];

    constructor(
        private rilievoService: RilievoService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute,
        private operaService: OperaService,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.rilievo = this.route.snapshot.data['additionalInformation'].rilievo;
        this.opereAssociateList = this.route.snapshot.data['additionalInformation'].opereAssociate;
        this.criteriaForm = this.rilievoService.generateFormRilievo(this.rilievo);
    }

   public deleteRilievo() {
        const modal = this.modalService.open(LayoutConfirmModalComponent,{size: 'xs'});
        modal.componentInstance.description = 'il Rilievo selezionato e le associazioni appartenenti ad esso verranno eliminate, si vuole procedere comunque? Si consiglia di eliminare l\'opera per eventuali errori di associazione.'
        modal.componentInstance.confirm = () => { 
            this.rilievoService.delete(this.rilievo.idRilievo).subscribe(response => {
                if (this.utilsService.genericResponse204NoContent(response)) {
                    this.router.navigate(['../..'], { relativeTo: this.route });
                }
            });
        };
    }

    public save() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showWarning(CoreI18nConfigs.messages.fieldRequired);
            this.criteriaForm.markAllAsTouched();
            return;
        } else if(this.criteriaForm.get('dataInizioRilievo')?.value && this.criteriaForm.get('dataFineRilievo')?.value &&(new Date(this.criteriaForm.get('dataInizioRilievo')?.value).getTime() > new Date(this.criteriaForm.get('dataFineRilievo')?.value).getTime())) {
            this.utilsService.showWarning('La data di inizio rilievo dev\'essere minore o uguale a quella di fine.');
            return;
        }
        this.criteriaForm.markAsUntouched();
        this.rilievoService.update(this.criteriaForm.getRawValue()).subscribe({
            next: (x) => {
                this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
            },
            complete : () => {
                this.operaService.search({idRilievo: this.criteriaForm.get('idRilievo')?.value}, this.paginator.getQueryPaginator(this.tableSort)).subscribe(opereList => {
                    this.opereAssociateList = opereList;
                });
            }
        });
        

    }

}
